<template>
  <section class="Nav">
    <div class="Nav__logo">
      <img
        src="../../assets/img/home/barlogo-1.png"
        alt=""
        v-if="USER.mostParentId != '255'"
      >
      <img
        src="../../assets/img/home/logo(3).png"
        alt=""
        v-else
      >
    </div>
    <div class="Nav__content">
      <div
        class="Nav__item"
        :class="{Nav__item_on: !!$route.path.match(item.value)}"
        v-for="item in menuList"
        :key="item.value"
        @click="jump(item)"
      >{{item.label}}</div>
    </div>
    <el-dropdown
      placement="bottom-end"
      trigger="hover"
    >
      <span class="Nav__user">
        <i class="Nav__user-icon iconfont icon-user"></i>
        {{USER ? USER.username : ''}}
        {{USER && USER.type === 1?"管理员":"监控员"}}
        <i class="Nav__dropdown-icon iconfont icon-dropdown"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="dialogVisible = true">修改密码 </el-dropdown-item>
        <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <EditPsw :visible.sync="dialogVisible" @onSuccess="loginOut" />

  </section>

</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import EditPsw from '@/components/EditPsw/index.vue';

export default {
  components:{
    EditPsw
  },
  data() {
    return {
      dialogVisible: false,
      menuList: [
        { value: "HomePage", label: "首页" },
        { value: "monitorCenter", label: "实时监控" },
        { value: "playback", label: "轨迹回放" },
        { value: "reportCenter", label: "报表中心" },
        // { value: "report", label: "报表中心" },
        // { value: "environmental", label: "环境监测" },
        { value: "deviceManage", label: "设备管理" },
        { value: "deviceRenewal", label: "设备续费" },
        { value: "userManage", label: "用户管理" },
      ],

    };
  },

  computed: {
    ...mapState(["USER"])
  },
  created(){
      this.addressInfo();
  },
  methods: {
    ...mapMutations(["COMMIT_USER",'COMMIT_ADDRESS']),
    ...mapActions(["DISPATCH_CLEARCHACE"]),
    //获取所有位置信息
    async addressInfo(){
        await this.$API.getAllRegoinInfo().then(res=>{
            console.log(res);
            this.COMMIT_ADDRESS(res.data);
        }).catch(error=>{
            console.log(error)
        })
    },
    async confirm() {
      try {
        await this.$refs.pwdInfo.validate();
        const { oldPassword, newPassword } = this.pwdInfo;
        await this.$API.updatePassword({
          newPassword: newPassword,
          password: oldPassword
        });
        this.dialogVisible = true;
        this.loginOut();
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error ? error.msg : "请输入正确的字段",
          type: "error"
        });
      }
    },
    async jump(item) {
      console.log(item)
      if (item.label === "轨迹回放") {
        let routeData = this.$router.resolve({ name: item.value });
        window.open(routeData.href, "_blank");
      } else {

        this.$route.name !== item.value &&
          this.$router.push({ name: item.value });
      }
      // this.$router.push({path: 'playback', query: {vehInfo: JSON.stringify(this.vehInfo)}})
    },
    async loginOut() {
      try {
        await this.$API.logout({});
        this.COMMIT_USER(null);
        this.$router.push("/login");
        this.DISPATCH_CLEARCHACE({ Vue: this });
      } catch (error) {
        console.error(error);
        this.$msg({
          showClose: true,
          message: error.msg,
          type: "error"
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.Nav {
  height: 60px;
  line-height: 60px;
  display: flex;
  background: rgba(25, 26, 27, 1);

  &__logo {
    display: flex;
    align-items: center;
    width: 320px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    color: #ffffff;
    user-select: none;
    padding-left: 32px;
    box-sizing: border-box;
  }

  &__content {
    flex: 1;
    display: flex;
    user-select: none;
  }

  &__item {
    color: rgba(132, 135, 139, 1);
    border-bottom: 2px solid transparent;
    padding: 0 20px;
    transition: border-color 0.3s, background-color 0.3s, color 0.3s;
    cursor: pointer;

    &:hover {
      color: #fff;
      background: rgba(42, 44, 47, 1);
    }

    &_on {
      color: #fff;
      background: rgba(42, 44, 47, 1);
      border-color: rgba(0, 211, 184, 1);
    }
  }

  &__user {
    padding: 0 40px;
    color: #fff;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: center;
    font-size: 16px;
    user-select: none;
  }

  &__user-icon {
    margin-right: 10px;
    font-size: 22px;
  }

  &__dropdown-icon {
    margin-left: 10px;
    font-size: 14px;
  }
}
</style>
